<!--
 * @Author: your name
 * @Date: 2022-06-13 12
-->
<template>
  <div>
    <div class="footer">
      <div class="footer-row">
        <div class="footer-top-row">
          <div class="footer-btn-list" v-for="(item,index) in btnList" :key="index">
            <img class="img-icon" @click="showEwm(item.ewm)" :src="item.img" alt="">
            <div class="name" >{{item.name}}</div>
          </div>
          <van-popup v-model="showEwmPopop">
            <img class="ewm-icon" :src="ewm" alt="">
          </van-popup>
        </div>
        <!-- <div class="navigation-row">
          <div class="navigation-details" v-for="(item,index) in navigationList" :key="index">{{item.name}}</div>
        </div> -->
        <div class="footer-center-row">
          <div class="lxkf">联系客服：<a href="">400-007-1768</a></div>
          <div class="lxkf" @click="toBaiduMap">公司地址：重庆市九龙坡区聚业路116号</div>
          <div class="lxkf">工作时间：周一至周五 08:30-17:00（节假日正常 休息）</div>
        </div>
        <div class="footer-bottom-row">
          <div class="text">隆鑫通用动力股份有限公司</div>
          <div class="text">COPYRIGHT© 2022 LONGXING ALL RIGHTS</div>
          <div class="text">RESERVED <span @click="toIcp">渝ICP备11000576号</span></div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
import { Popup } from 'vant';
export default {
  components:{
    [Popup.name]:Popup
  },
  data(){
    return{
      ewm:'',
      showEwmPopop:false,
      btnList:[
        {
          id:1,
          name:'官方微博',
          img:require('../assets/icon/home/weibo.png'),
          ewm:require('../assets/icon/home/footer-wb.png')
        },{
          id:2,
          name:'官方微信',
          img:require('../assets/icon/home/weixin.png'),
          ewm:require('../assets/icon/home/footer-wx.jpg')
        },{
          id:3,
          name:'抖音账号',
          img:require('../assets/icon/home/douyin.png'),
          ewm:require('../assets/icon/home/footer-dy.png')
        }
      ],
      navigationList:[
        // {
        //   id:1,
        //   name:'联系我们',
        // },
        // {
        //   id:2,
        //   name:"在线商城"
        // },
        // {
        //   id:3,
        //   name:'关于我们'
        // },
        // {
        //   id:4,
        //   name:'媒体中心'
        // }
      ]
    }
  },
  methods:{
    showEwm(val){
      if (val != 4) {
        this.showEwmPopop = true
        this.ewm = val
      }
    },
    toBaiduMap(){
      window.open('https://map.baidu.com/search/%E9%87%8D%E5%BA%86%E5%B8%82%E4%B9%9D%E9%BE%99%E5%9D%A1%E5%8C%BA%E4%B9%9D%E9%BE%99%E5%9B%AD%E5%8C%BA%E5%8D%8E%E9%BE%99%E5%A4%A7%E9%81%9399%E5%8F%B7/@11850638.125,3414702,19z?querytype=s&da_src=shareurl&wd=%E9%87%8D%E5%BA%86%E5%B8%82%E4%B9%9D%E9%BE%99%E5%9D%A1%E5%8C%BA%E4%B9%9D%E9%BE%99%E5%9B%AD%E5%8C%BA%E5%8D%8E%E9%BE%99%E5%A4%A7%E9%81%9399%E5%8F%B7&c=132&src=0&pn=0&sug=0&l=12&b=(11800578.46,3397260.19;11923458.46,3457228.19)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1','_blank')
    },
    toIcp(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index','_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.footer{
  width: 100%;
  background: #000000;
  .van-popup{
    background-color: transparent;
    width: 300px;
    height: 300px;
  }
  .van-popup--center{
    .ewm-icon{
      width: 90%;
      height: 90%;
    }
  }
  /deep/.van-overlay{
    background-color: rgba($color: #000000, $alpha: .3);
  }
  .footer-row{
    width: 92vw;
    margin: 0 auto;

    padding-top: 5.6vw;
    
    .footer-top-row{
      border-bottom: 1px solid #717171;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .footer-center-row{
      border-bottom: 1px solid #717171;
      .lxkf:nth-child(3){
        margin-bottom:40px;
      }
    }
    .footer-bottom-row{
      text-align: center;
      padding: 30px 0;
      .text{
        font-size: 4vw;
        color: #B7B7B7;
        line-height: 6.5333vw;
      }
    }
    .footer-btn-list{
      display: flex;
      margin-bottom: 5.6vw;
      align-items: center;
      flex-direction: column;
      .img-icon{
        width: 6.6667vw;
        height: 6.6667vw;
      }
      .name{
        font-size: 4vw;
        color: #B7B7B7;
        margin-top: 20px;
      }
    }
    .navigation-row{
      display: flex;
      justify-content:flex-start;
      .navigation-details{
        font-size: 4vw;
        color: #B7B7B7;
        margin-top: 3.6vw;
        margin-right: 5vw;
      }
    }
    .lxkf{
      font-size: 4vw;
      color: #B7B7B7;
      margin-top: 5.0667vw;
      line-height: 6.5333vw;
      a{
        color: #B7B7B7;
        font-size: 4vw;
      }
    }
  }
}
</style>